import {
  BarChart3,
  Boxes,
  Building2,
  CheckCircle2,
  FileInput,
  Files,
  Gauge,
  Inbox,
  LayoutDashboard,
  ListChecks,
  MailOpen,
  Network,
  PackageCheck,
  PanelsTopLeft,
  Landmark,
  BookOpenCheck,
  Palette,
  ReceiptText,
  Repeat2,
  ScrollText,
  ShieldCheck,
  Sparkles,
  ShoppingCart,
  Users,
  Wrench,
} from "lucide-react";

import type { View } from "@/lib/app-view";
import type { AppRole } from "@/lib/types";

export const navigation: {
  view: View;
  label: string;
  icon: typeof LayoutDashboard;
  group?: string;
  roles?: AppRole[];
}[] = [
  { view: "dashboard", label: "Command centre", icon: LayoutDashboard },
  { view: "setup", label: "Setup & launch", icon: Sparkles, roles: ["tenant_admin"] },
  { view: "actions", label: "Action & Event Centre", icon: ListChecks },
  {
    view: "inbox",
    label: "Company request inbox",
    icon: Inbox,
    group: "PROCURE",
    roles: ["requester", "procurement", "tenant_admin", "auditor"],
  },
  {
    view: "requisitions",
    label: "Requisitions",
    icon: FileInput,
    group: "PROCURE",
  },
  { view: "approvals", label: "Approvals", icon: CheckCircle2, roles: ["approver", "tenant_admin", "auditor"] },
  { view: "rfqs", label: "RFQs & quotes", icon: Repeat2, roles: ["approver", "procurement", "tenant_admin", "auditor"] },
  { view: "orders", label: "Purchase orders", icon: ShoppingCart, roles: ["procurement", "receiver", "finance", "tenant_admin", "auditor"] },
  { view: "receipts", label: "Goods receipts", icon: PackageCheck, roles: ["procurement", "receiver", "finance", "tenant_admin", "auditor"] },
  { view: "invoices", label: "Invoices & match", icon: ReceiptText, roles: ["finance", "tenant_admin", "auditor"] },
  { view: "money", label: "Money in motion", icon: Landmark, roles: ["approver", "finance", "tenant_admin", "auditor"] },
  { view: "value", label: "Value & obligations", icon: ShieldCheck, roles: ["approver", "procurement", "receiver", "finance", "tenant_admin", "auditor"] },
  { view: "reports", label: "Reports & compliance", icon: BarChart3, roles: ["finance", "tenant_admin", "auditor"] },
  { view: "exports", label: "Export Centre", icon: Files, roles: ["finance", "tenant_admin", "auditor"] },
  { view: "accounting", label: "Accounting bridge", icon: BookOpenCheck, roles: ["finance", "tenant_admin"] },
  { view: "assurance", label: "Executive & audit", icon: ListChecks, roles: ["finance", "tenant_admin", "auditor"] },
  { view: "control-passports", label: "Control Passports", icon: ShieldCheck, roles: ["approver", "procurement", "finance", "tenant_admin", "auditor"] },
  { view: "internal-controls", label: "Internal controls", icon: ShieldCheck, roles: ["approver", "procurement", "tenant_admin", "auditor"] },
  { view: "industry-templates", label: "Industry templates", icon: Building2, roles: ["tenant_admin"] },
  { view: "controlled-pilots", label: "Controlled pilots", icon: ShieldCheck, roles: ["tenant_admin"] },
  {
    view: "vendors",
    label: "Supplier companies",
    icon: Building2,
    group: "CONTROL",
    roles: ["procurement", "tenant_admin", "auditor"],
  },
  { view: "contracts", label: "Contracts & rates", icon: ScrollText, roles: ["procurement", "finance", "tenant_admin", "auditor"] },
  { view: "reorders", label: "Reorder plans", icon: Repeat2, roles: ["procurement", "receiver", "tenant_admin", "auditor"] },
  { view: "budgets", label: "Structure & budgets", icon: Gauge, roles: ["approver", "procurement", "finance", "tenant_admin", "auditor"] },
  { view: "network", label: "Group & franchises", icon: Building2, roles: ["tenant_admin"] },
  { view: "inventory", label: "Stock control", icon: Boxes, group: "OPERATE", roles: ["procurement", "receiver", "tenant_admin", "auditor"] },
  { view: "assets", label: "Assets & warranty", icon: Wrench, roles: ["procurement", "receiver", "finance", "tenant_admin", "auditor"] },
  { view: "campaigns", label: "Requirement bulletins", icon: MailOpen, roles: ["procurement", "tenant_admin", "auditor"] },
  { view: "plan", label: "Plan & entitlements", icon: PanelsTopLeft, group: "WORKSPACE", roles: ["tenant_admin"] },
  { view: "team", label: "Team & access", icon: Users, roles: ["tenant_admin"] },
  { view: "branding", label: "Workspace identity", icon: Palette, roles: ["tenant_admin"] },
  { view: "content", label: "Editorial desk", icon: ScrollText, roles: [] },
  { view: "trusted-network", label: "Trusted network", icon: Network, roles: [] },
  { view: "audit", label: "Audit trail", icon: ListChecks, roles: ["finance", "tenant_admin", "auditor"] },
];
